import React from 'react';
import { siteConfig, navigation } from '../data/content';

const Footer = ({ onNavigate, onScrollTo }) => {
  const handleNavClick = (item) => {
    if (item.type === 'page') {
      onNavigate(item.id);
    } else {
      onScrollTo(item.id);
    }
  };

  return (
    <footer className="py-12 bg-stone-900 text-stone-400">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="font-display text-xl text-white">
            {siteConfig.companyName}
          </div>

          <div className="flex gap-8">
            {navigation.map((item) => (
              <button
                key={item.id}
                onClick={() => handleNavClick(item)}
                className="font-body text-xs tracking-widest uppercase hover:text-amber-400 transition-colors"
              >
                {item.label}
              </button>
            ))}
          </div>

          <p className="font-body text-xs text-stone-500">
            © {new Date().getFullYear()} All rights reserved
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
